import { TableColumnType } from 'src/types/table';

export const REQUIRED_CLAIMS_GRID_COLUMNS = ['ESHOP_CLAIM_ID', 'ID', 'STATUS', 'ORDER_ID'];
export const REQUIRED_CLAIMS_GRID_ALL_PROVIDERS_COLUMNS = [...REQUIRED_CLAIMS_GRID_COLUMNS, 'ESHOP_KEY'];

const timestampFields: TableColumnType[] = [
    {
        key: 'IN_PROCESS_AT',
        label: 'inProcessAt',
        type: 'dateTime',
        defaultShow: false,
    },
    {
        key: 'MORE_INFO_NEEDED_AT',
        label: 'moreInfoNeededAt',
        type: 'dateTime',
        defaultShow: false,
    },
    {
        key: 'ACCEPTED_EXPECT_COMPENSATION_AT',
        label: 'acceptedExpectCompensationAt',
        type: 'dateTime',
        defaultShow: false,
    },
    {
        key: 'ACCEPTED_PENDING_CLIENT_COMPENSATION_AT',
        label: 'acceptedPendingClientCompensationAt',
        type: 'dateTime',
        defaultShow: false,
    },
    {
        key: 'REJECTED_AT',
        label: 'rejectedAt',
        type: 'dateTime',
        defaultShow: false,
    },
    {
        key: 'CANCELED_AT',
        label: 'canceledAt',
        type: 'dateTime',
        defaultShow: false,
    },
]
export const baseColumns: TableColumnType[] = [
    {
        key: 'ID',
        label: 'id',
        type: 'id',
    },
    {
        key: 'FCN',
        label: 'fcn',
        defaultShow: true,
    },
    {
        key: 'ESHOP_CLAIM_ID',
        label: 'eshopClaimId',
        type: 'id',
        defaultShow: true,
    },
    {
        key: 'CREATED_AT',
        label: 'createdAt',
        type: 'dateTime',
        defaultShow: true,
    },
    {
        key: 'UPDATED_AT',
        label: 'updatedAt',
        type: 'dateTime',
        defaultShow: false,
    },
    {
        key: 'CLAIM_CAUSE',
        type: 'select',
        selectOption: 'claimReasonCodes',
        label: 'claimCause',
        defaultShow: true,
    },
    {
        key: 'DESCRIPTION',
        label: 'description',
        defaultShow: true,
        customStyle: { maxWidth: '190px' },
        customStyleHeader: { maxWidth: '190px' },
    },
    {
        key: 'RESOLVER',
        label: 'resolver',
        type: 'select',
        selectOption: 'claimsResolverCodes',
        defaultShow: true,
    },
    {
        key: 'STATUS',
        label: 'statusOfClaim',
        type: 'select',
        selectOption: 'claimStatusCodes',
        defaultShow: true,
        customRender: true,
        optionStyleFce: true,
    },
    {
        key: 'INFORMATION_ADDED_AT',
        label: 'informationAddedAt',
        type: 'dateTime',
    },
    {
        key: 'CLOSED_AT',
        label: 'closedAt',
        defaultShow: true,
        type: 'dateTime',
    },
    {
        key: 'CLAIM_CAUSE_OTHERS_TYPE',
        label: 'otherClaimCause',
        customStyle: { maxWidth: '190px' },
        customStyleHeader: { maxWidth: '190px' },
    },
    {
        key: 'ESHOP_NOTE',
        label: 'eshopNote',
        customStyle: { maxWidth: '190px' },
        customStyleHeader: { maxWidth: '190px' },
    },
    {
        key: 'TRACKING_NUMBER',
        label: 'trackingNumber',
    },
    {
        key: 'RETURN_TRACKING_NUMBER',
        label: 'returnTrackingNumber',
    },
    {
        key: 'SHIPPER',
        label: 'shipper',
        type: 'select',
        selectOption: 'shipperCodes',
    },
    {
        key: 'ORDER_ID',
        label: 'orderId',
        type: 'number',
    },
    {
        key: 'ORDER_TYPE',
        label: 'orderType',
        type: 'select',
        selectOption: 'orderTypeCodes',
    },
    {
        key: 'ESHOP_ORDER_ID',
        label: 'eshopOrderId',
    },
    {
        key: 'CCTV',
        label: 'cctv',
        type: 'select',
        selectOption: 'boolNumberCodes',
    },
    {
        key: 'TRANSPORT_PRICE',
        label: 'transportPrice',
        type: 'string',
    },
    {
        key: 'GOODS_PRICE',
        label: 'goodsPrice',
        type: 'string',
    },
    {
        key: 'TOTAL_SERVICE_PRICE',
        label: 'totalServicePrice',
        type: 'string',
    },
    {
        key: 'COMPENSATION_CURRENCY',
        label: 'compensationCurrency',
        type: 'select',
        selectOption: 'currencyCodes',
    },
];
const errorLoggingFields: TableColumnType[] = [
    {
        key: 'PACKED_AT',
        label: 'packedAt',
        type: 'dateTime',
        defaultShow: false,
    },
    {
        key: 'PACKER_NAME',
        label: 'packerName',
        defaultShow: false,
    },
    {
        key: 'ERROR_RESPONSIBLE',
        label: 'errorResponsible',
        defaultShow: false,
    },
    {
        key: 'ERROR_DEPARTMENT',
        label: 'errorDepartment',
        type: 'select',
        selectOption: 'claimErrorDepartmentCodes',
        defaultShow: false,
    },
    {
        key: 'ERROR_CATEGORY',
        label: 'errorCategory',
        type: 'select',
        selectOption: 'claimErrorCategoryCodes',
        defaultShow: false,
    },
    {
        key: 'ERROR_DESCRIPTION',
        label: 'errorDescription',
        defaultShow: false,
        customStyle: { maxWidth: '190px' },
        customStyleHeader: { maxWidth: '190px' },
    },
    {
        key: 'ERROR_SEVERITY',
        label: 'errorSeverity',
        type: 'select',
        selectOption: 'claimErrorSeverityCodes',
        defaultShow: false,
    },
    {
        key: 'VIDEO_LINK',
        label: 'videoLink',
        defaultShow: false,
        customStyle: { maxWidth: '190px' },
        customStyleHeader: { maxWidth: '190px' },
    },
];

const timestampFieldsSkladonUser: TableColumnType[] = timestampFields.map((column) =>
    column.key === 'IN_PROCESS_AT'
        ? { ...column, label: 'inProcessAtLast' }
        : column,
);

export const allColumnsSkladonUser: TableColumnType[] = [
    ...baseColumns,
    {
        key: 'NOTE',
        label: 'note',
        customStyle: { maxWidth: '190px' },
        customStyleHeader: { maxWidth: '190px' },
    },
    {
        key: 'CARRIER_INVOICE_REFERENCE',
        label: 'carrierInvoiceReference',
    },
    {
        key: 'ISSUES_MONTH_ORIGIN',
        label: 'issuesMonthOrigin',
        type: 'date',
    },
    ...errorLoggingFields,
    {
        key: 'IN_PROCESS_AT_FIRST',
        label: 'inProcessAtFirst',
        type: 'dateTime',
        defaultShow: false,
    },
    ...timestampFieldsSkladonUser
];

export const allColumns: TableColumnType[] = [
    ...baseColumns,
    ...timestampFields
];

export const allColumnsWithProvider: TableColumnType[] = [
    {
        key: 'providerName',
        label: 'providerName',
        allwaysShow: true,
        forceFirst: true,
        disableFilter: true,
        disableSort: true,
    },
    ...allColumns,
];

export const allColumnsWithProviderSkladonUser: TableColumnType[] = [
    {
        key: 'providerName',
        label: 'providerName',
        allwaysShow: true,
        forceFirst: true,
        disableFilter: true,
        disableSort: true,
    },
    ...allColumnsSkladonUser,
];

export const extendProductColumns: TableColumnType[] = [
    { key: 'SKU', label: 'productSKU' },
    { key: 'NAME', label: 'productName' },
    { key: 'CLAIMED_QUANTITY', label: 'productClaimedQuantity' },
    { key: 'RESEND_QUANTITY', label: 'productResendQuantity' },
];
